<template>
    <div class="position-relative">
        <v-btn fab x-small color="red" dark
               v-show="filter_repetitive !== -1 && filter_repetitive !== null"
               @click="filter_repetitive = -1 ; $emit('update', filter_repetitive)"
               style="position: absolute; right: 0; top: 0; z-index: 4">
            <v-icon>mdi-filter-remove-outline</v-icon>
        </v-btn>
        <v-radio-group
            :class="css_class || ''"
            v-model="filter_repetitive"
            hide-details
            label="Rhythmus"
            @change="$emit('update', filter_repetitive)"
        >
            <!--<v-radio
                label="-"
                :value="-1"
            ></v-radio>-->
            <v-radio
                v-for="(val, key) in repetitivities"
                :key="key"
                :label="getResolvedAppointmentRepetition(key).label"
                :value="key"
            ></v-radio>
        </v-radio-group>
    </div>
</template>

<script>

import _ from 'lodash'

export default {
    components: {},
    props : ['css_class'],
    data : () => ({
        filter_repetitive : null,
    }),
    computed : {
        repetitivities () {
            if(_.get(this.$root, 'enums.byKey.appointment_repetitivities', false) !== false) {
                return this.$root.enums.byVal.appointment_repetitivities
            }
            else
                return {}
        }
    },
    created () {},
    mounted () {},
    methods : {
        reset () {
            this.filter_repetitive = null
        }
    }
};
</script>
